import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoNotes = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 500 500",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			id: "freepik--Floor--inject-1--inject-4",
			children: /* @__PURE__ */ _jsx("ellipse", {
				id: "freepik--floor--inject-1--inject-4",
				cx: 244.99,
				cy: 353.84,
				rx: 230,
				ry: 125.13,
				style: { fill: "#f5f5f5" }
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "freepik--Shadows--inject-1--inject-4",
			children: [
				/* @__PURE__ */ _jsx("polygon", {
					id: "freepik--Shadow--inject-1--inject-4",
					points: "285.61 449.1 167.81 381.09 279.51 316.67 397.31 384.68 285.61 449.1",
					style: { fill: "#e6e6e6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "freepik--shadow--inject-1--inject-4",
					d: "M52.77,379.93l23.47,13.5a9.43,9.43,0,0,0,8.56,0l155.92-90.17c2.37-1.36,2.37-3.58,0-4.94l-23.46-13.51a9.49,9.49,0,0,0-8.56,0L52.77,375C50.41,376.35,50.41,378.57,52.77,379.93Z",
					style: { fill: "#e6e6e6" }
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					id: "freepik--shadow--inject-1--inject-4",
					cx: 373.66,
					cy: 305.87,
					rx: 44.51,
					ry: 25.7,
					style: { fill: "#e6e6e6" }
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					id: "freepik--shadow--inject-1--inject-4",
					cx: 312.53,
					cy: 297.14,
					rx: 15.01,
					ry: 8.67,
					style: { fill: "#e6e6e6" }
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "freepik--Notebook--inject-1--inject-4",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M67.8,380.26l-7.91-4.57-.09-.06a4.24,4.24,0,0,1-1.66-3.81V128.39l160.6-92.73,8,4.64L66.17,133V376.45A4.33,4.33,0,0,0,67.8,380.26Z",
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M226.77,40.3V283.73a13.26,13.26,0,0,1-6,10.38L72.16,379.92a4.36,4.36,0,0,1-4,.53l-.34-.19a4.3,4.3,0,0,1-1.63-3.8V133Z",
					style: { fill: "#f0f0f0" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "218.73 35.66 226.77 40.3 66.17 133.03 58.13 128.39 218.73 35.66",
					style: { fill: "#fafafa" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M66.67,382.74l-1.85-1.06-.09-.06a4.29,4.29,0,0,1-1.66-3.82V132.6l164.62-95,2,1.13L65,133.72V378.93A4.32,4.32,0,0,0,66.67,382.74Z",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M66.67,382.74l-1.85-1.06-.09-.06a4.29,4.29,0,0,1-1.66-3.82V132.6l164.62-95,2,1.13L65,133.72V378.93A4.32,4.32,0,0,0,66.67,382.74Z",
					style: { opacity: .1 }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M229.66,38.69v245.2a13.26,13.26,0,0,1-6,10.38L71,382.4a4.36,4.36,0,0,1-4,.53l-.34-.19a4.3,4.3,0,0,1-1.63-3.8V133.73Z",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M229.66,38.69v245.2a13.26,13.26,0,0,1-6,10.38L71,382.4a4.36,4.36,0,0,1-4,.53l-.34-.19a4.3,4.3,0,0,1-1.63-3.8V133.73Z",
					style: { opacity: .05 }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "227.69 37.55 229.66 38.69 65.04 133.73 63.07 132.59 227.69 37.55",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "227.69 37.55 229.66 38.69 65.04 133.73 63.07 132.59 227.69 37.55",
					style: {
						fill: "#fff",
						opacity: .4
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M69.82,384.55,68,383.49l-.09-.06a4.27,4.27,0,0,1-1.66-3.81V134.41l164.62-95,2,1.13-164.62,95V380.75A4.3,4.3,0,0,0,69.82,384.55Z",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M69.82,384.55,68,383.49l-.09-.06a4.27,4.27,0,0,1-1.66-3.81V134.41l164.62-95,2,1.13-164.62,95V380.75A4.3,4.3,0,0,0,69.82,384.55Z",
					style: { opacity: .1 }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M232.81,40.5V285.71a13.24,13.24,0,0,1-6,10.37L74.18,384.21a4.31,4.31,0,0,1-4,.53l-.34-.18a4.32,4.32,0,0,1-1.63-3.81V135.54Z",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "230.84 39.37 232.81 40.5 68.19 135.54 66.22 134.41 230.84 39.37",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "230.84 39.37 232.81 40.5 68.19 135.54 66.22 134.41 230.84 39.37",
					style: {
						fill: "#fff",
						opacity: .4
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M79.84,387.22l-7.91-4.57-.09-.06a4.26,4.26,0,0,1-1.66-3.81V135.35l160.6-92.73,8,4.64L78.21,140V383.41A4.34,4.34,0,0,0,79.84,387.22Z",
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M238.81,47.26V290.69a13.27,13.27,0,0,1-6,10.38L84.2,386.87a4.34,4.34,0,0,1-4,.54l-.34-.19a4.34,4.34,0,0,1-1.63-3.81V140Z",
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "230.78 42.62 238.81 47.26 78.21 139.98 70.18 135.35 230.78 42.62",
					style: { fill: "#fafafa" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M90.25,142.3c2.22-1.28,4-.25,4,2.32a8.87,8.87,0,0,1-4,6.95c-2.21,1.28-4,.24-4-2.32A8.88,8.88,0,0,1,90.25,142.3Z",
					style: {
						fill: "#e0e0e0",
						mixBlendMode: "multiply"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M79,110.27c-4.37-2.52-8.56-2.89-11.79-1s-5,5.67-5,10.73a25.36,25.36,0,0,0,.7,5.69l2.68-1.55a21.28,21.28,0,0,1-.41-4.14c0-4,1.25-6.85,3.52-8.17s5.41-1,8.83,1c7.63,4.4,13.84,15.15,13.84,24a12.36,12.36,0,0,1-1.13,5.53,6.25,6.25,0,0,1-2.4,2.62l-.24.13a8.67,8.67,0,0,0-1.26,3.49,8.69,8.69,0,0,0,3-1.05,9.43,9.43,0,0,0,4.16-5.27,16.11,16.11,0,0,0,.85-5.45C94.27,127.05,87.4,115.14,79,110.27Z",
					style: { fill: "#455a64" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M109.75,131c2.22-1.28,4-.25,4,2.32a8.87,8.87,0,0,1-4,6.95c-2.21,1.28-4,.24-4-2.32A8.9,8.9,0,0,1,109.75,131Z",
					style: {
						fill: "#e0e0e0",
						mixBlendMode: "multiply"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M98.45,99c-4.36-2.52-8.55-2.89-11.79-1s-5,5.68-5,10.73a25.36,25.36,0,0,0,.7,5.69L85,112.86a22.08,22.08,0,0,1-.41-4.14c0-4,1.25-6.85,3.53-8.17s5.4-1,8.82,1c7.63,4.4,13.84,15.15,13.84,24a12.2,12.2,0,0,1-1.13,5.53,6.31,6.31,0,0,1-2.4,2.62l-.24.13a8.67,8.67,0,0,0-1.26,3.49,8.62,8.62,0,0,0,3-1,9.49,9.49,0,0,0,4.17-5.26,16.69,16.69,0,0,0,.85-5.46C113.78,115.79,106.91,103.88,98.45,99Z",
					style: { fill: "#455a64" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M129.26,119.78c2.21-1.28,4-.24,4,2.32a8.88,8.88,0,0,1-4,7c-2.22,1.28-4,.24-4-2.31A8.88,8.88,0,0,1,129.26,119.78Z",
					style: {
						fill: "#e0e0e0",
						mixBlendMode: "multiply"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M118,87.75c-4.37-2.52-8.56-2.89-11.8-1s-5,5.68-5,10.73a25.29,25.29,0,0,0,.7,5.69l2.68-1.55a22.08,22.08,0,0,1-.41-4.14c0-4,1.25-6.85,3.53-8.17s5.4-1,8.82,1c7.63,4.4,13.84,15.15,13.84,24a12.2,12.2,0,0,1-1.13,5.53,6.31,6.31,0,0,1-2.4,2.62l-.23.13a8.6,8.6,0,0,0-1.27,3.49,8.74,8.74,0,0,0,3-1,9.48,9.48,0,0,0,4.16-5.26,16.69,16.69,0,0,0,.85-5.46C133.28,104.53,126.41,92.62,118,87.75Z",
					style: { fill: "#455a64" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M148.76,108.52c2.21-1.28,4-.24,4,2.32a8.88,8.88,0,0,1-4,7c-2.22,1.28-4,.25-4-2.31A8.88,8.88,0,0,1,148.76,108.52Z",
					style: {
						fill: "#e0e0e0",
						mixBlendMode: "multiply"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M137.46,76.49c-4.37-2.52-8.56-2.89-11.79-1s-5,5.68-5,10.73a24.75,24.75,0,0,0,.71,5.69L124,90.34a22,22,0,0,1-.41-4.14c0-4,1.25-6.85,3.53-8.17s5.4-1,8.82,1c7.63,4.4,13.84,15.15,13.84,24a12.28,12.28,0,0,1-1.12,5.54,6.36,6.36,0,0,1-2.41,2.61l-.23.13a8.6,8.6,0,0,0-1.27,3.49,8.74,8.74,0,0,0,3-1,9.48,9.48,0,0,0,4.16-5.26,16.43,16.43,0,0,0,.85-5.46C152.78,93.27,145.91,81.36,137.46,76.49Z",
					style: { fill: "#455a64" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M168.26,97.26c2.21-1.28,4-.24,4,2.32a8.88,8.88,0,0,1-4,7c-2.22,1.28-4,.25-4-2.31A8.88,8.88,0,0,1,168.26,97.26Z",
					style: {
						fill: "#e0e0e0",
						mixBlendMode: "multiply"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M157,65.23c-4.37-2.52-8.56-2.89-11.79-1s-5,5.68-5,10.73a24.75,24.75,0,0,0,.71,5.69l2.68-1.55a21.23,21.23,0,0,1-.42-4.14c0-4,1.26-6.85,3.53-8.17s5.41-1,8.83,1c7.63,4.4,13.83,15.15,13.83,24a12.28,12.28,0,0,1-1.12,5.54,6.46,6.46,0,0,1-2.41,2.62l-.23.12a8.75,8.75,0,0,0-1.27,3.49,8.94,8.94,0,0,0,3-1,9.51,9.51,0,0,0,4.16-5.27,16.43,16.43,0,0,0,.85-5.46C172.28,82,165.41,70.1,157,65.23Z",
					style: { fill: "#455a64" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M187.76,86c2.22-1.28,4-.24,4,2.32a8.86,8.86,0,0,1-4,7c-2.22,1.28-4,.25-4-2.31A8.87,8.87,0,0,1,187.76,86Z",
					style: {
						fill: "#e0e0e0",
						mixBlendMode: "multiply"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M176.46,54c-4.37-2.52-8.56-2.88-11.79-1s-5,5.68-5,10.73a24.73,24.73,0,0,0,.7,5.69L163,67.82a21.23,21.23,0,0,1-.42-4.14c0-4,1.26-6.85,3.53-8.17s5.41-.95,8.83,1c7.63,4.4,13.83,15.15,13.83,24a12.25,12.25,0,0,1-1.12,5.54,6.43,6.43,0,0,1-2.4,2.62l-.24.12a8.75,8.75,0,0,0-1.27,3.49,8.73,8.73,0,0,0,3-1A9.51,9.51,0,0,0,190.93,86a16.43,16.43,0,0,0,.85-5.46C191.78,70.76,184.91,58.84,176.46,54Z",
					style: { fill: "#455a64" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M207.26,74.74c2.22-1.28,4-.24,4,2.32a8.86,8.86,0,0,1-4,7c-2.22,1.28-4,.25-4-2.31A8.87,8.87,0,0,1,207.26,74.74Z",
					style: {
						fill: "#e0e0e0",
						mixBlendMode: "multiply"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M196,42.71c-4.37-2.52-8.56-2.88-11.79-1s-5,5.68-5,10.73a24.73,24.73,0,0,0,.7,5.69l2.68-1.55a21.23,21.23,0,0,1-.42-4.14c0-4,1.26-6.85,3.53-8.17s5.41-.94,8.83,1c7.63,4.4,13.84,15.15,13.84,24a12.24,12.24,0,0,1-1.13,5.54,6.43,6.43,0,0,1-2.4,2.62l-.24.12A8.75,8.75,0,0,0,203.28,81a8.73,8.73,0,0,0,3-1,9.51,9.51,0,0,0,4.16-5.27,16.43,16.43,0,0,0,.85-5.46C211.28,59.5,204.41,47.59,196,42.71Z",
					style: { fill: "#455a64" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M226.76,63.48c2.22-1.28,4-.24,4,2.32a8.86,8.86,0,0,1-4,7c-2.22,1.28-4,.25-4-2.31A8.87,8.87,0,0,1,226.76,63.48Z",
					style: {
						fill: "#e0e0e0",
						mixBlendMode: "multiply"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M215.46,31.45c-4.37-2.52-8.56-2.88-11.79-1s-5,5.68-5,10.73a24.66,24.66,0,0,0,.7,5.69L202,45.3a21.23,21.23,0,0,1-.42-4.14c0-3.95,1.26-6.85,3.53-8.17s5.41-.94,8.83,1c7.63,4.4,13.84,15.16,13.84,24a12.41,12.41,0,0,1-1.13,5.54,6.37,6.37,0,0,1-2.4,2.62l-.24.13a8.49,8.49,0,0,0-1.26,3.48,8.75,8.75,0,0,0,3-1,9.5,9.5,0,0,0,4.16-5.27,16.13,16.13,0,0,0,.85-5.46C230.78,48.24,223.91,36.33,215.46,31.45Z",
					style: { fill: "#455a64" }
				}),
				/* @__PURE__ */ _jsxs("g", {
					style: { opacity: .30000000000000004 },
					children: [/* @__PURE__ */ _jsx("path", {
						d: "M90.52,160.69l136-78.51c2.37-1.37,4.29-.26,4.29,2.47v8.66a9.43,9.43,0,0,1-4.28,7.41l-136,78.51c-2.37,1.37-4.28.26-4.28-2.47V168.1A9.46,9.46,0,0,1,90.52,160.69Z",
						style: {
							fill: "none",
							stroke: "#8A6BD6",
							strokeMiterlimit: 10
						}
					}), /* @__PURE__ */ _jsx("line", {
						x1: 230.77,
						y1: 88.98,
						x2: 86.24,
						y2: 172.43,
						style: {
							fill: "none",
							stroke: "#8A6BD6",
							strokeMiterlimit: 10
						}
					})]
				}),
				/* @__PURE__ */ _jsxs("g", {
					style: { opacity: .30000000000000004 },
					children: [
						/* @__PURE__ */ _jsx("path", {
							d: "M90.52,188.51l136-78.51c2.37-1.36,4.28-.26,4.28,2.47V278.74a9.43,9.43,0,0,1-4.28,7.41l-136,78.51c-2.36,1.37-4.28.26-4.28-2.47V195.92A9.46,9.46,0,0,1,90.52,188.51Z",
							style: {
								fill: "none",
								stroke: "#8A6BD6",
								strokeMiterlimit: 10
							}
						}),
						/* @__PURE__ */ _jsx("line", {
							x1: 230.77,
							y1: 116.8,
							x2: 86.24,
							y2: 200.25,
							style: {
								fill: "none",
								stroke: "#8A6BD6",
								strokeMiterlimit: 10
							}
						}),
						/* @__PURE__ */ _jsx("line", {
							x1: 230.77,
							y1: 126.07,
							x2: 86.24,
							y2: 209.52,
							style: {
								fill: "none",
								stroke: "#8A6BD6",
								strokeMiterlimit: 10
							}
						}),
						/* @__PURE__ */ _jsx("line", {
							x1: 230.77,
							y1: 135.34,
							x2: 86.24,
							y2: 218.79,
							style: {
								fill: "none",
								stroke: "#8A6BD6",
								strokeMiterlimit: 10
							}
						}),
						/* @__PURE__ */ _jsx("line", {
							x1: 230.77,
							y1: 144.61,
							x2: 86.24,
							y2: 228.07,
							style: {
								fill: "none",
								stroke: "#8A6BD6",
								strokeMiterlimit: 10
							}
						}),
						/* @__PURE__ */ _jsx("line", {
							x1: 230.77,
							y1: 153.88,
							x2: 86.24,
							y2: 237.34,
							style: {
								fill: "none",
								stroke: "#8A6BD6",
								strokeMiterlimit: 10
							}
						}),
						/* @__PURE__ */ _jsx("line", {
							x1: 230.77,
							y1: 163.15,
							x2: 86.24,
							y2: 246.61,
							style: {
								fill: "none",
								stroke: "#8A6BD6",
								strokeMiterlimit: 10
							}
						}),
						/* @__PURE__ */ _jsx("line", {
							x1: 230.77,
							y1: 172.42,
							x2: 86.24,
							y2: 255.88,
							style: {
								fill: "none",
								stroke: "#8A6BD6",
								strokeMiterlimit: 10
							}
						}),
						/* @__PURE__ */ _jsx("line", {
							x1: 230.77,
							y1: 181.7,
							x2: 86.24,
							y2: 265.15,
							style: {
								fill: "none",
								stroke: "#8A6BD6",
								strokeMiterlimit: 10
							}
						}),
						/* @__PURE__ */ _jsx("line", {
							x1: 230.77,
							y1: 190.97,
							x2: 86.24,
							y2: 274.42,
							style: {
								fill: "none",
								stroke: "#8A6BD6",
								strokeMiterlimit: 10
							}
						}),
						/* @__PURE__ */ _jsx("line", {
							x1: 230.77,
							y1: 200.24,
							x2: 86.24,
							y2: 283.69,
							style: {
								fill: "none",
								stroke: "#8A6BD6",
								strokeMiterlimit: 10
							}
						}),
						/* @__PURE__ */ _jsx("line", {
							x1: 230.77,
							y1: 209.51,
							x2: 86.24,
							y2: 292.96,
							style: {
								fill: "none",
								stroke: "#8A6BD6",
								strokeMiterlimit: 10
							}
						}),
						/* @__PURE__ */ _jsx("line", {
							x1: 230.77,
							y1: 218.78,
							x2: 86.24,
							y2: 302.24,
							style: {
								fill: "none",
								stroke: "#8A6BD6",
								strokeMiterlimit: 10
							}
						}),
						/* @__PURE__ */ _jsx("line", {
							x1: 230.77,
							y1: 228.05,
							x2: 86.24,
							y2: 311.51,
							style: {
								fill: "none",
								stroke: "#8A6BD6",
								strokeMiterlimit: 10
							}
						}),
						/* @__PURE__ */ _jsx("line", {
							x1: 230.77,
							y1: 237.32,
							x2: 86.24,
							y2: 320.78,
							style: {
								fill: "none",
								stroke: "#8A6BD6",
								strokeMiterlimit: 10
							}
						}),
						/* @__PURE__ */ _jsx("line", {
							x1: 230.77,
							y1: 246.6,
							x2: 86.24,
							y2: 330.05,
							style: {
								fill: "none",
								stroke: "#8A6BD6",
								strokeMiterlimit: 10
							}
						}),
						/* @__PURE__ */ _jsx("line", {
							x1: 230.77,
							y1: 255.87,
							x2: 86.24,
							y2: 339.32,
							style: {
								fill: "none",
								stroke: "#8A6BD6",
								strokeMiterlimit: 10
							}
						}),
						/* @__PURE__ */ _jsx("line", {
							x1: 230.77,
							y1: 265.14,
							x2: 86.24,
							y2: 348.59,
							style: {
								fill: "none",
								stroke: "#8A6BD6",
								strokeMiterlimit: 10
							}
						}),
						/* @__PURE__ */ _jsx("line", {
							x1: 230.77,
							y1: 274.41,
							x2: 86.24,
							y2: 357.86,
							style: {
								fill: "none",
								stroke: "#8A6BD6",
								strokeMiterlimit: 10
							}
						})
					]
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M92.28,199.28c-.08-4.69-.08-8.41,0-9.12a2.68,2.68,0,0,1,.39-1.35s0,0,.07-.06.36.14.75,1.08c.25.47.64,1.3.86,1.83s.84,1.71,1.29,2.69c.82,1.81,1.46,3.09,1.82,3.73l.2.31v-1.53c0-.84,0-2.79-.08-4.29s-.07-3.53-.07-4.49c0-1.94,0-2.05.32-2.22s.36-.1.42.15.08,1.27.12,2.58,0,3.33.08,4.43c.09,3.34.1,7.17,0,7.5-.12.55-.43.84-.67.64a25.2,25.2,0,0,1-2.06-4c-.34-.76-.82-1.79-1.09-2.27L93.69,193c-.38-.76-.48-1-.51-.85s0,6.35.07,8.79c.06,2,0,2.66-.16,3s-.32.37-.44.26S92.35,203.12,92.28,199.28Z",
					style: { fill: "#455a64" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M100.31,197.32a4.87,4.87,0,0,1-.12-1.51,6.61,6.61,0,0,1,.36-2.61,8.65,8.65,0,0,1,1.2-2.16,1.89,1.89,0,0,1,1.66-.89,1.63,1.63,0,0,1,1.41,1.36,11.61,11.61,0,0,1,.07,2.78,6.28,6.28,0,0,1-1.84,3.73,2.17,2.17,0,0,1-1.08.62C101.17,198.81,100.57,198.34,100.31,197.32Zm3.84-4.12a2,2,0,0,0-.15-1,1.47,1.47,0,0,0-.76-.92c-.13,0-.29,0-.62.22a2.34,2.34,0,0,0-1.11,1.4,5,5,0,0,0-.48,3,3.07,3.07,0,0,0,.5,1.45c.37.43.79.33,1.52-.35A5.93,5.93,0,0,0,104.15,193.2Z",
					style: { fill: "#455a64" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M107.12,191l0-2.84-.14.12a1.88,1.88,0,0,1-1,.59c-.31,0-.47-.12-.4-.34.14-.4.31-.59.88-1a3.12,3.12,0,0,0,.6-.46,5.34,5.34,0,0,0,0-1c0-1.55.1-4.1.17-4.42s.1-.31.19-.36.14,0,.22.08.24.75.31,3.16l.07,1.79s.22,0,.53-.19c.57-.28.74-.27.82.07a.45.45,0,0,1-.06.41c-.11.17-.21.25-.66.51a5.11,5.11,0,0,0-.58.41,37.33,37.33,0,0,0-.07,5.87c0,.24,0,.74.09,1.09,0,.58,0,.65-.09.87s-.43.46-.58.38S107.15,194.67,107.12,191Z",
					style: { fill: "#455a64" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M110.19,191.14a9.43,9.43,0,0,1,1.66-5.88c.43-.57,1.15-1.24,1.73-1.18a1,1,0,0,1,.77,1.22,10.73,10.73,0,0,1-2.36,4.2c-.74.88-.86,1.11-.83,1.44.09.54.41,1,.72.93a5.25,5.25,0,0,0,2.52-2.3c.16-.3.21-.35.38-.42s.29,0,.29.15a7.41,7.41,0,0,1-1,1.77c-.9,1.25-1.53,1.78-2.22,1.9C110.8,193.13,110.31,192.57,110.19,191.14Zm3-4.64a1.45,1.45,0,0,0,.24-.83c0-.25,0-.33-.12-.36a.3.3,0,0,0-.26.06,2.21,2.21,0,0,0-.7.68,6.56,6.56,0,0,0-1.2,3.27c0,.14,0,.15.29-.14A14.63,14.63,0,0,0,113.19,186.5Z",
					style: { fill: "#455a64" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M116.74,189.71c-.43-.1-.55-.26-.54-.63s0-.3.21-.42a1.12,1.12,0,0,1,.69-.12,2.16,2.16,0,0,0,1.5-.39,1.15,1.15,0,0,0,.67-1.19c0-.41,0-.46-.15-.71A4,4,0,0,0,118,185.2a1.56,1.56,0,0,1-.82-1,2.67,2.67,0,0,1,.37-2.48,1.29,1.29,0,0,1,.42-.38c.63-.36,1.63-.32,1.93.23a.44.44,0,0,1,0,.49c-.12.36-.38.44-.88.2-.19-.07-1-.25-1,.6s.19,1,1,1.44a2.69,2.69,0,0,1,1.17,3.08,3.47,3.47,0,0,1-2,2.18A2.53,2.53,0,0,1,116.74,189.71Z",
					style: { fill: "#455a64" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M121.72,181.39a2.68,2.68,0,0,1,.3-1c.15-.36.48-.64.65-.44a1.12,1.12,0,0,1,.1,1.08,1.19,1.19,0,0,1-.68.61C121.91,181.71,121.76,181.57,121.72,181.39Zm0,5.46a2.63,2.63,0,0,1,.3-1c.15-.36.48-.64.65-.44a1.12,1.12,0,0,1,.1,1.08,1.21,1.21,0,0,1-.68.6C121.91,187.18,121.76,187,121.72,186.85Z",
					style: { fill: "#455a64" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M165.26,188.86c0-.21-.37-.15-.49-.1a8.62,8.62,0,0,0-2.56,2.3l-.87,1c-.76.81-1.22.88-1.38.2,0,0-.27-.22-.36-.22-2.06,0-2.86,1.8-4.25,3-.49-1.73-2.21-.09-3,1-1.6,2.25-4.91,2.91-6.76,5,0-.67-.15-1.33-.82-1.35a2.56,2.56,0,0,0-.48-1.6.33.33,0,0,0-.3-.08c-1.6.34-2.53,2.5-3.08,4,.11-1.93.21-3.87.23-5.8,0-.37-.67-.24-.68.09-.11,3.12-1.3,5.38-3.11,7.84a13,13,0,0,1-1.53,1.78,7.15,7.15,0,0,1-2.5,1.28,2.9,2.9,0,0,0-1,.49,5.83,5.83,0,0,1-.87.63c-.16.08-.44,0-.66.08a5.27,5.27,0,0,0-1.62,1.79c-.6-.48-1-.42-1.69.13-.52.39-1,1.18-1.49,1.5-1.3.76-.57-.14-1.24-.84-.87-.92-1.81-.07-2.56.56a7.28,7.28,0,0,0-2.09,2.78c-.18-.87-.6-1.6-1.5-1.45-1.35.21-2.19,2.69-2.71,3.64a8.21,8.21,0,0,1-2.58,3.29,5.14,5.14,0,0,1-2,.9c-.21,0-.32-.15-.56-.05a4.55,4.55,0,0,0-1,.67c-.69.45.27.8-1.09.4-.88-.26-.78-.59-1.18-1.27-.09-.14-.31-.11-.43-.06a4.08,4.08,0,0,0-1.43,1.43c-.56.74-1.88,3.25-2.87,3.32-1.65.12-1.69-4.08-1.72-5.06-.06-2,.19-4,.26-6,0-.22-.47-.22-.5,0a57.15,57.15,0,0,1-2,8c-.86,2.49-2.19,4.81-2.31,7.49,0,.16.33.23.34.08.2-2.79,1.66-5.27,2.55-7.87.46-1.34.84-2.74,1.17-4.14a23.31,23.31,0,0,0,0,4.26c.12,1,.11,3.65,1.44,3.94,1,.22,2.14-1.26,2.64-1.86.37-.44,1.24-2.18,1.81-2.4,1.13-.43.89.9,1.51,1.36s1,.23,1.59-.21c.77-.57.45-1.13,1.83-1.41.33-.06.68.17,1.08,0a8,8,0,0,0,3-2.59,27,27,0,0,0,1.71-3.35c.16-.31.67-1.57,1.1-1.65l1.32,1.44c0,.48,0,.95,0,1.43s.66.23.68-.09c.13-1.83,1.1-4.7,3.25-4.76,1.26,0,.8.57,1.59,1.32a.4.4,0,0,0,.54,0c.63-.62,2.21-3.23,3.27-2.22a.41.41,0,0,0,.59-.1c.26-.33,1.38-2.27,1.82-1.69.13.17.42.09.54,0a6.94,6.94,0,0,1,1.89-1.34c.24-.12.53-.13.79-.24a7.83,7.83,0,0,0,2.92-2.54,17.08,17.08,0,0,0,2.87-4.72c-.08,1.6-.18,3.2-.29,4.8a36.78,36.78,0,0,0-.48,7.7c0,.39.69.21.7-.13.11-2.57.3-5.14.47-7.71.1-.42.2-.84.33-1.26.38-1.25.75-3,1.77-3.92.79-.67,1.23-.3,1.27.34a1.67,1.67,0,0,0-.3,1.33c.05.28.54.12.63,0a1.75,1.75,0,0,0,.11-.24c.34-.16.46-.06.34.3s0,.62-.07.92.58.17.67,0c.88-1.8,3.77-3.44,5.55-4.26a3.71,3.71,0,0,0,1.13-.55c.1-.1,2.39-3.6,2.6-1.83,0,.23.32.28.49.16,1-.68,1.46-2,2.57-2.53,2.69-1.39.92.11,2.42.36.94.15,4.42-4.14,4.39-4.3.06.32.7.12.64-.21Z",
					style: { fill: "#455a64" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M200.07,167.17a14.82,14.82,0,0,1-2.58,3.26c-.45,1.21-1.55,1.56-3.29,1a1.76,1.76,0,0,0-.38-.39c-.16,0-.44-.13-.65-.13-1.3.06-2,3.52-3.07,2.05-.11-.15-.37-.08-.49,0a5.46,5.46,0,0,0-1.87,1.92c-.18.31-.28.89-.49,1.09l-.15.15a.86.86,0,0,0-.32.09c-.08,0-.59-.16-.78-.12-.38.09-.62.48-.83.77a17.44,17.44,0,0,0-.95,2.06,1.9,1.9,0,0,0-.16.33.67.67,0,0,0-.28-.74c-1-.66-1.91.9-2.53,2-.21-1.11-.57-2.28-1.88-1.74-1.58.64-2.12,2-2.61,3.43,0-2-.27-4.92-1.93-4.62-1.1.21-2.23,2.25-2.72,3.07-.69,1.14-1,2.84-1.88,3.8-.19.2.28.34.43.2,1.23-1.18,1.78-3.5,2.8-4.89.42-.58,1.09-1.8,2.08-.94.28.25.2,1.38.25,1.81.15,1.16.15,2.31.27,3.47,0,.38.6.18.71-.05.35-.72.5-1.46.82-2.2a3.21,3.21,0,0,1,1.16-1.83c1.31,0,1.95.51,1.92,1.61.07.34.52.21.68,0,.42-.53,1.76-3.24,2.19-1.67.05.2.22.23.41.2,1-.17,1.77-4.3,2.69-3,.11.15.38.09.49,0,1-.71,1.54-4.36,3-2.69a.32.32,0,0,0,.31.08c.84-.25,1-1,1.54-1.59s.21-.58,1-.83c1.44-.46.17,0,1.05.13.6.1.77.35,1.44.3a3.4,3.4,0,0,0,2.12-1.08c.64-.73,1.09-1.64,1.73-2.4a6.4,6.4,0,0,0,1.29-1.86C200.7,167,200.17,167,200.07,167.17Z",
					style: { fill: "#455a64" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M221.94,157.25a2.3,2.3,0,0,0-1.38.45c-1.18.65-2.29,1.56-3.45,2.26-.6.36-1.1.9-1.67,1.25-1.46.9-1.87-.2-2.82-1.23a.34.34,0,0,0-.35,0c-1.23.31-1.19,1.27-2.14,1.87-.63.39-.6.47-1.1-.25-.31-.43-.32-.9-.71-1.31-.13-.14-.35-.08-.49,0-1.12.68-1.77,1.88-2.66,2.82s-2,3.07-3.41,3.56c-.25.09,0,.34.17.29,1-.22,1.48-1,2.15-1.8s1.34-1.48,2-2.22c.34-.37,1-1.52,1.3-1.62,1.38-.41.89,2.83,2.7,1.63.49-.33.56-1.07,1-1.41,1.35-1,1.25-.26,2,.25s.88,1.09,1.76.88c.24-.05.38-.31.59-.41a3,3,0,0,0,.4-.54,7.7,7.7,0,0,1,2.66-1.65c1.05-.71,2.07-1.94,3.34-2.21C222.16,157.75,222.39,157.23,221.94,157.25Z",
					style: { fill: "#455a64" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M139.64,223.42c-.46,1.77-3.13,4.11-4.57,1.87-.63-1-.27-3.14-.27-4.28v-5.3c0-1.31,0-2.63,0-4,0-.49-.78-.3-.78.1v2.55c0,4.22-.35,8.2-2.34,12.17a13.3,13.3,0,0,1-1.63,3c-1.28,1.4-2.45,1.23-3.23.6.17-.32.32-.64.48-.92.31-.52,1.21-1.46.93-2.18-.39-1-2.21-.94-2.72-.08a3,3,0,0,0,.4,3.18c-.63.87-1.42,1.78-2.38.85a.43.43,0,0,0-.58.08c-.5.6-.74,1.35-1.2,1.94-.62.79-.67,2-1.94,2a1,1,0,0,1-.7-.21c-.63-.52.17-1.7.29-2.32a3.52,3.52,0,0,0-.3-2.61.34.34,0,0,0-.46-.1,4.1,4.1,0,0,0-2.27,4.64c.11.36.6.86.4,1.14s-1,.31-1.28.2a2.94,2.94,0,0,1-1.27-.94c-.88-1-2.38,3-2.67,3.52-.69,1.3-1.17,2.51-2.45,3.32a1.22,1.22,0,0,1-.78.22c-.6-.11-.41-.76-.52-1.18,0,.2-.07-1,0-.93,0-.16-.28-.16-.39-.13-.73.19-.77.64-1.22,1.31-.21.32-.54.9-.78,1.2a1.94,1.94,0,0,1-1.14,1.1h-.55c-.67.48-1.18,1.22-1.86,1.67-1.11.73-2.07,1.21-2.2-.56a10.74,10.74,0,0,0-.15-1.7c-.06-.27-.5-.14-.61,0a15.26,15.26,0,0,0-1.73,3.14c-.28.7-2.22,5.38-3,2.2-.23-1,1-2.82,1.43-3.71.8-1.71.88-2.18,3.41-2.44.31,0,1.23.08,1.42.08s.19-.28,0-.29c-1.65,0-2.7-.89-4.12.39-1,.87-1.3,2.27-1.83,3.39a6.05,6.05,0,0,0-1,3.24c.12,1.11.77,1.89,1.93,1.3.68-.35,1.12-1.38,1.45-2,.74-1.44,1.27-2.89,2.07-4.27.07,1.07,0,2.08.83,2.92a.34.34,0,0,0,.37.07,11.09,11.09,0,0,0,2.58-1.83c.73-.57,1.79-.73,2.45-1.34a13.63,13.63,0,0,0,1.55-2.37,8,8,0,0,0,.51-.71,6.09,6.09,0,0,0,0,1.1c.33,1.38,1.38,1.28,2.39.55a8.13,8.13,0,0,0,2-2.56c.72-1.19,1.21-3,2.16-4.09a2.31,2.31,0,0,0,3.77.65s.1-.11.15-.15a3.45,3.45,0,0,0,3.48-.85,6.23,6.23,0,0,0,1.13-1.64c.17-.38.36-.77.55-1.14q.45-.82.93-.12c.79,0,.87.3,1.64-.17a3.28,3.28,0,0,0,1.08-1.22,2.52,2.52,0,0,0,1.89.7c2.48-.28,3.94-4.47,4.75-6.31a17.94,17.94,0,0,0,.83-2.4c-.06,1.24,0,2.59.74,3.4,2.24,2.37,5.12-.4,5.73-2.72C140.56,222.92,139.75,223,139.64,223.42Zm-22.59,9.32c.2-1.17,1.9-2.93,1.64-.78a8.59,8.59,0,0,1-.32,1.33,5,5,0,0,1-.33.92,1.54,1.54,0,0,1-.08.19C117.07,234.48,116.79,234.21,117.05,232.74Zm8.76-4.94a.77.77,0,0,1,.39-.7.7.7,0,0,1,.35,0,.81.81,0,0,1,.46.14.72.72,0,0,1,.26.55,1.3,1.3,0,0,1-.33.93l-.53.76-.1.14s-.35-.75-.38-.84a2.6,2.6,0,0,1-.13-.78A.86.86,0,0,1,125.81,227.8Z",
					style: { fill: "#455a64" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M182,196.59l-.25,0a.32.32,0,0,0-.26.24,12.77,12.77,0,0,1-2.42,3.67c-2.59,2.55-2.49-1.21-2.63-2.53,0-.27-.36-.25-.53-.14a6.76,6.76,0,0,0-2.45,3.1c-.15.3-1,2.26-1.18,2.2.25.09-.13-1.73-.29-2s-.26-.12-.36-.08a8.8,8.8,0,0,0-4.85,5.78c-.29-.26-.66-.3-1.22,0s-1.1,1.78-1.56,1.85c0,0-.55-.7-.78-.76-1.21-.33-2.67,1.49-3.38,2.18-1.87,1.85-.89-.87-2.57-1a.4.4,0,0,0-.37.14,34.25,34.25,0,0,1-2.55,4c-.89,1.11-1.61,1.54-2-.22-.25-1.21.78-2.52.94-3.74,0-.28-.44-.27-.56-.1-2.12,3-3.55,6.2-6.15,8.86-.19.19.28.31.43.16,2.2-2.15,3.55-4.69,5.15-7.21-.52,1.59-1.08,3.63.17,4.13s2.45-1.57,2.94-2.26a14.71,14.71,0,0,1,1.65-2.6c.64-.57.22-.56.88.21.25.29.29.78.64,1a1,1,0,0,0,1.21.1c.57-.34,3-4.8,3.76-2.3.05.15.26.18.39.13.57-.21,2.28-3,2.82-1.46.09.28.63.15.64-.12.09-2,1.18-3.27,2.46-4.63.54-.57,1.08-1.69,1.91-.72a10.82,10.82,0,0,0,.13,1.25c.06.2.33.17.47.11,1.78-.81,2-3.7,3.52-5.15.07,1.54,0,3.74,2.12,3.37a3.22,3.22,0,0,0,1.93-1.51c.48-.66.92-1.33,1.41-2,.07-.1.87-1.54.92-1.56C182.5,196.9,182.3,196.55,182,196.59Z",
					style: { fill: "#455a64" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M215.58,178.49a1.9,1.9,0,0,0-1.5.5c-.4.32-.62.82-1,1.16-2,1.76-3-.17-3.21-2-.05-.38-.56-.18-.69,0-.82,1.25-.48,2.64-1.5,4-.8,1-3.75,4.65-4.3,1.59-.06-.32-.48-.23-.64-.05-.77.84-1.24,1.87-2,2.75-.43.51-1.66,1.93-2.09,1.91-1.15-.07-1.16-1.82-1.23-2.53,0-.32-.45-.23-.61-.08-.38.36-3.6,7.09-4.49,6.4-.24-.18-.77.16-.48.39,1.7,1.33,3.77-3.42,4.9-5.56,0,1.16.09,2.35,1.65,2.05,2.12-.4,3.19-2.84,4.4-4.47.48,1.31,1.58,1.69,2.9.73a14,14,0,0,0,2.95-3.42,6.82,6.82,0,0,0,.7-2.32c.3,1.09.88,2.07,2.23,2.11,1.85.06,2.15-2.56,3.88-2.67C215.79,179,216,178.51,215.58,178.49Z",
					style: { fill: "#455a64" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M123.84,248.65c.64-.76,1.1-1.37,2.15-1.38a.56.56,0,0,1,.29.06.46.46,0,0,1,.18.16,2.45,2.45,0,0,0,1.75,1.18c1,.07,2.75-1.54,4-3.23,1,.39,2.75-1,3.52-1.71.41-.38-.18-.74-.54-.4a2.53,2.53,0,0,1-2.24,1.43c-.06,0-.14,0-.14-.07.08-.68,1.55-2.41.39-2.9s-1.8,1.47-1.74,2.22a2.44,2.44,0,0,0,.23,1c-.28.46-.58.92-.91,1.36a13.91,13.91,0,0,1-1.14,1,1.78,1.78,0,0,1-.7.49,2,2,0,0,1-1.29-.27c-.67-.52.5-1.27.84-1.68a8.6,8.6,0,0,0,1.22-1.87c.45-1,.66-2.32-.79-2.37-2,0-3.05,2.83-2.68,4.93a3.88,3.88,0,0,0-1.19.31,6.07,6.07,0,0,0-1.71,1.64c-.82,1-1.21,1.55-1.15-.14,0-.32-.51-.25-.61,0a20.41,20.41,0,0,1-2.61,4.93c-.68.78-1.72,1.66-2.51,1.28a12.37,12.37,0,0,0,1.75-4c.23-1,1-4.13-.9-4.28-1.53-.12-2,3.07-2.22,4a6.87,6.87,0,0,0,.32,4.32l.14.21a10.8,10.8,0,0,1-1.14,1.39c-.71.71-1.69,1.78-2.8,1.77a.67.67,0,0,1-.56-.22c-.46-.58.65-1.7.89-2.23a4.89,4.89,0,0,0,.37-2.67.26.26,0,0,0-.25-.22l-.28,0a.44.44,0,0,0-.39.18,7.5,7.5,0,0,0-1.33,4.55l-.73.8c-.63.71-1.84,2.82-2.76,1.06a.33.33,0,0,0-.28-.1c-.61.12-.68.35-1.08.89s-.83,1.81-1.82.91c0,0,0-1.27-.07-1.44s-.47-.14-.59,0c-.95,1.06-1.38,2.75-2.32,3.84a14.27,14.27,0,0,1,.66-2.27c.13-.37-.53-.35-.63-.05-.79,2.16-1.63,4.54-3.28,6.18a2.09,2.09,0,0,1-2.55.83,2.71,2.71,0,0,1,.25-3.21,5.66,5.66,0,0,1,2-2.45q1.35-.63,1.17.27c0,.25.49.21.52,0,.13-1.24-1-1.1-1.94-.69-1.52.7-3.36,3.57-3.25,5.25.09,1.46,1.66,1.88,2.88,1.43,1.7-.61,2.82-2.44,3.64-4.32a.51.51,0,0,0,.4-.07c1.22-.85,1.68-2.49,2.48-3.78,0,.95-.13,1.93,1.21,1.68.9-.17,1-.87,1.52-1.46.89-1,.29-.53,1.16,0,1.21.73,2-.72,2.66-1.52l1-1.08a1.71,1.71,0,0,0,.17.33c1.12,1.36,2.56,0,3.5-.86a15.18,15.18,0,0,0,2-2.16c1.9,1.74,4.44-3,5.64-5.53a.63.63,0,0,0,.89.55C123,250.17,123.55,249,123.84,248.65Zm-12.63,7c-.06.15-.13.29-.2.43-.17.33-.26.44-.29,0a5,5,0,0,1,.38-1.94,1.22,1.22,0,0,1,.39-.64c.08-.06.22-.09.26,0a.13.13,0,0,1,0,.08,3.09,3.09,0,0,1,0,.61,3.29,3.29,0,0,1-.34,1Zm4.68-1.77a4.39,4.39,0,0,1-.27-1.76,11.1,11.1,0,0,1,.76-4.37.91.91,0,0,1,.13-.26.58.58,0,0,1,.69-.14.91.91,0,0,1,.48.57,2.4,2.4,0,0,1,.09.76,8,8,0,0,1-.35,2.58,18.33,18.33,0,0,1-1,2.1c-.13.25-.27.49-.41.72Zm11.22-7.7a.4.4,0,0,1-.11-.14.62.62,0,0,1,0-.27,7.13,7.13,0,0,1,.29-2.16c.24-.68.71-1.38,1.52-1.34a.59.59,0,0,1,.32.09c.77.52,0,1.7-.33,2.23a7.64,7.64,0,0,1-.84,1C127.79,245.84,127.37,246.42,127.11,246.23Z",
					style: { fill: "#455a64" }
				}),
				/* @__PURE__ */ _jsx("path", { d: "M138.62,242.6c-.4,0-.62.62-.12.62S139.13,242.6,138.62,242.6Z" })
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "freepik--Character--inject-1--inject-4",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M356.82,131.67c-4.72,8-9.27,14.93-12.46,18.26-6.06,2.82-20.3,7.15-25.88,7.88a4.15,4.15,0,0,1-2.79-.66c-2.19-1.44-3.89-1.67-6.2-2.47-1.8-.62-2.57-1.49-2.91-1.16a2.06,2.06,0,0,0,.19,2.87,15.25,15.25,0,0,0,2.86,2.14,17,17,0,0,1-7.54.13c-4.82-1.27-7.1,1.05-3.84,6.29,1.17,1.87,5.77,4.87,15.09,4.06a80.81,80.81,0,0,0,9.9-1.17c8.94-1.91,18.87-3.75,25-5.58a15.85,15.85,0,0,0,5.94-4.11c10.27-11.71,13.67-20.06,18.18-27.65L372,118.11C364.67,117.89,360.77,125,356.82,131.67Z",
					style: { fill: "#b16668" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M373.21,117.89a11.72,11.72,0,0,0-11.14,4.76c-5,6.4-13.85,21.77-13.85,21.77s2.9,7.71,10.71,9l12.54-17S377.41,124.73,373.21,117.89Z",
					style: { fill: "#455a64" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 392.15,
					y: 290.64,
					width: 8.18,
					height: 14.58,
					style: { fill: "#b16668" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "371.98 289.87 363.8 290.16 363.39 274.73 371.98 274.44 371.98 289.87",
					style: { fill: "#b16668" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M401.47,164.43c0,8.13-1.19,73.57-1.19,73.57.19,2.34,2.29,6.66,1.84,15.64-.62,12.21-1.45,44.29-1.45,44.29a10.36,10.36,0,0,1-9.1.19s-7.73-44.43-9.2-56.53c-1.28-10.56-3.45-46.11-3.45-46.11l-4.43,41.34a50.08,50.08,0,0,1,1,13.53c-.38,5.59-3,34.74-3,34.74a10.78,10.78,0,0,1-9.44.75s-4.65-43.89-4.74-49C358.2,231,361,164.34,361,164.34Z",
					style: { fill: "#37474f" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M392.15,301V299.8c-.79.36-2.6,7.58-5.85,10.66-2.58,2.45-6.09,5.28-7,8s4.9,4.41,7.31,4c2.8-.52,7.65-2.57,8.87-4.48s1.79-4.71,2.78-6.1,3.27-2.95,3.8-4.57c.3-.89-.05-2.83-.46-4.47s-.79-3.16-1.29-3v.93a6.34,6.34,0,0,1-4.08,1.44C395,302.22,392.14,302,392.15,301Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M363.72,287.53c-.43,0-.77.64-1.71,1.7a17.9,17.9,0,0,1-4.81,3.6c-3.06,1.6-9,4.05-11.71,5.32-1.68.79-1.6,2.9.14,4.11s5.94,2.07,11,.9c2.75-.64,6.33-3.28,8.59-3.14s6.5.11,8.17-1.09,1-3.76.53-6c-.52-2.4-1.16-6.14-1.92-6v.83c-1,1.55-6.06,2.18-8.22,1Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M378.92,195.48a30,30,0,0,1-11.38-6.8s2.19,4.29,8.73,8.27l-1.4,36.92Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M396.9,119.1s6.72,1.56,6.26,13.75l-1.41,19.42,0,29.13c-6,6.81-32.67,6.32-41.79-.54,0,0,1-34.48,1.65-47.75.44-9.44,2.61-14.18,11.88-15.22l11.4.5Z",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "379.05 126.47 377.58 136.7 374.17 136.64 378.02 137.25 379.05 126.47",
					style: { opacity: .1 }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M388.31,93.77a12.43,12.43,0,0,1-12.18,12.67c-6.72,0-10.7-5.83-12.17-12.67-2.69-12.52,5.45-12.68,12.17-12.68A12.43,12.43,0,0,1,388.31,93.77Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M394.52,98.89s-1.87,9.14-2.62,10.64a4,4,0,0,1-2.29,1.93l.13-6.43Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M392.17,85.81s1.34-.34,2.76,1.88c1.22,1.91,1.5,6.19-.41,11.2l-3.52.42Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M390,99.32c.7.44,1.71-1,2.58-1.92s3.7-2.24,5.12.86-1.25,7.36-3.48,8.09c-3.86,1.26-4.43-1.32-4.43-1.32l-.3,14.47c-5.11,7.91-16.69,7.63-12.53-.38v-4.4a23.1,23.1,0,0,1-5.19.27c-2.83-.45-4.62-2.78-5.47-6-1.38-5.13-1.91-9.27-.74-19.36,1.29-11.06,13.63-11.17,20.3-6.8S390,99.32,390,99.32Z",
					style: { fill: "#b16668" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M391.06,81.43a3,3,0,0,0-2.72-4.26,2.94,2.94,0,0,0-1.88.68,2.95,2.95,0,0,0-5.06-1.07,3.72,3.72,0,0,0-6-1A3.8,3.8,0,0,0,368,77.28c0,.14,0,.27,0,.41a5,5,0,0,0-1.55-.24,5.15,5.15,0,1,0,0,10.3,5.21,5.21,0,0,0,2.23-.51,3.65,3.65,0,0,0,7.07.35,2.89,2.89,0,0,0,5.27-.06,3.2,3.2,0,0,0,5.08-.2c1,.47,1.27,3.72,1.45,4.66.62,3.17,1.13,8.54,2.33,8.56.35,0,1.7-2.32,2.58-3.15,1.21-1.15,1.46-10.68,1.46-10.68S395.64,82.32,391.06,81.43Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M389.51,116.26a18.52,18.52,0,0,1-5,6.27,14.11,14.11,0,0,1-6.06,2.58,13.4,13.4,0,0,1,4.28,4.8c1.27,2.81,10.49-6.93,10.27-11,0,0-1.49-4.91-3.43-5.26Z",
					style: { fill: "#455a64" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M378.44,125.11s-2.77-1.38-1.53-6v-4.4l-1.21.16a10.66,10.66,0,0,0-2.93,5.06c-.28,1.26-1,7.65.26,8.92S376,125.45,378.44,125.11Z",
					style: { fill: "#455a64" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M376.92,114.72s6.32-1.33,8.54-2.55a7.51,7.51,0,0,0,3.05-3.15,10.46,10.46,0,0,1-1.74,3.71c-1.61,2.15-9.85,3.74-9.85,3.74Z",
					style: { fill: "#9a4a4d" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M378.44,97.67a1.27,1.27,0,1,0,1.27-1.37A1.32,1.32,0,0,0,378.44,97.67Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M380.48,92.21l2.71,1.56a1.74,1.74,0,0,0-.63-2.25A1.48,1.48,0,0,0,380.48,92.21Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M377.49,106.79l-2.89,1.13a1.52,1.52,0,0,0,2,1A1.7,1.7,0,0,0,377.49,106.79Z",
					style: { fill: "#9a4a4d" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M366.82,93.37l2.47-2a1.47,1.47,0,0,0-2.15-.35A1.76,1.76,0,0,0,366.82,93.37Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M367.9,97.3a1.27,1.27,0,1,0,1.27-1.38A1.33,1.33,0,0,0,367.9,97.3Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "374.68 96.24 374.54 104.24 369.99 103.2 374.68 96.24",
					style: { fill: "#9a4a4d" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M423.92,156c-1.91-6.77-8.89-20.09-12.39-26.48-5-9.09-9.69-10.34-14.84-10.41-1.9,2.45-2.11,13.88,4.38,20.7,2.49,5.23,10.39,18.63,10.39,18.63-.19,1.41-5.54,16.3-7.76,21.09a3.79,3.79,0,0,1-2,1.88c-2.3,1-3.35,2.23-5.18,3.65-1.44,1.12-2.54,1.28-2.44,1.72a2.08,2.08,0,0,0,2.48,1.32,14.2,14.2,0,0,0,3.22-1.18,18.92,18.92,0,0,1-3.84,4.8c-3.49,3.18-3.31,5.84,2.64,6.78,3.73.59,7.05-1.27,11.09-9.08,1.16-2.24,2.4-5.64,3.83-8.52,3-5.94,4-7.22,6.31-11.69C423.26,162.75,424.76,159,423.92,156Z",
					style: { fill: "#b16668" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M395.64,119.1a14.38,14.38,0,0,1,10.12,2.4c5.09,3.44,15.23,25.23,15.23,25.23s.26,5.5-13.23,7.28l-7.37-13.71S393.56,133.72,395.64,119.1Z",
					style: { fill: "#455a64" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M302.4,294.5a2.48,2.48,0,0,1-.16-.8l0,1.72a2.83,2.83,0,0,0,0,.3v.07a1.55,1.55,0,0,0,0,.31l0,.15a2.27,2.27,0,0,0,.06.25l.15.39c.06.13.13.26.2.39l0,0a6.34,6.34,0,0,0,2.46,2.26,15.75,15.75,0,0,0,14.26-.15,7.11,7.11,0,0,0,1.43-1.07,1.58,1.58,0,0,0,.23-.22.86.86,0,0,0,.13-.14,3.11,3.11,0,0,0,.23-.28,4.38,4.38,0,0,0,.62-1.05,1.25,1.25,0,0,0,.09-.25.08.08,0,0,0,0,0l.07-.25a2.7,2.7,0,0,0,.07-.41c0-.11,0-.21,0-.31a.53.53,0,0,1,0-.12l0-2a3.25,3.25,0,0,1-.12,1,5.69,5.69,0,0,0-2.84-3.09,15.75,15.75,0,0,0-14.26.14A5.63,5.63,0,0,0,302.4,294.5Zm20,.43a.61.61,0,0,1,0-.14A.61.61,0,0,0,322.41,294.93Z",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M300.23,87l20.18-.24,0,2,2,204.58a3.25,3.25,0,0,1-.12,1,5.68,5.68,0,0,1-2.79,3.17,15.72,15.72,0,0,1-14.26.14,6.25,6.25,0,0,1-2.46-2.25,3.06,3.06,0,0,1-.37-.83,2.48,2.48,0,0,1-.16-.8.71.71,0,0,1,0-.14v-.07Z",
					style: { fill: "#f0f0f0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M303.23,91.07c-4-2.23-4-5.92-.08-8.24a15.78,15.78,0,0,1,14.26-.14c4,2.23,4,5.92.09,8.24A15.8,15.8,0,0,1,303.23,91.07Z",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M304.55,72.48a2.41,2.41,0,0,0-.08.25l-4,12.93v0l0,.1a2,2,0,0,0-.07.23l0,.14h0c-.41,1.75.54,3.59,2.89,4.91a15.8,15.8,0,0,0,14.27-.14c2.27-1.35,3.2-3.15,2.82-4.87h0l0-.1a4.2,4.2,0,0,0-.17-.5l0-.11v0l-4.23-12.82a3.24,3.24,0,0,0-1.6-1.73,9,9,0,0,0-8.16.08A3.34,3.34,0,0,0,304.55,72.48Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M308.21,240.91a.06.06,0,0,0,0,.06v.27a1.82,1.82,0,0,0,1,1.31,5.64,5.64,0,0,0,5.08-.05,1.9,1.9,0,0,0,1-1.29h0v-.35L313.82,80.67l-7.17-4Z",
					style: { fill: "#455a64" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M313.94,92.29l-.12-11.62-7.17-4,.16,15.74A17.13,17.13,0,0,0,313.94,92.29Z",
					style: { fill: "#37474f" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M306.82,67h0L303.2,78.69a2,2,0,0,0-.1.32c-.32,1.25.36,2.57,2,3.52a11.12,11.12,0,0,0,10.08-.11c1.6-.94,2.27-2.21,2-3.41,0,0,0-.06,0-.08l-.1-.33-3.89-11.76h0a1.85,1.85,0,0,0-.9-1,5.05,5.05,0,0,0-4.59,0A1.79,1.79,0,0,0,306.82,67Z",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M306.82,67h0L303.2,78.69a2,2,0,0,0-.1.32c-.32,1.25.36,2.57,2,3.52a11.12,11.12,0,0,0,10.08-.11c1.6-.94,2.27-2.21,2-3.41,0,0,0-.06,0-.08l-.1-.33-3.89-11.76h0a1.85,1.85,0,0,0-.9-1,5.05,5.05,0,0,0-4.59,0A1.79,1.79,0,0,0,306.82,67Z",
					style: { opacity: .1 }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M307.72,65.91a5.05,5.05,0,0,1,4.59,0,1.85,1.85,0,0,1,.9,1h0l2,6c.31.93-.15,1.94-1.4,2.68a8.14,8.14,0,0,1-7.34.08A2.38,2.38,0,0,1,305,73l.07-.23L306.81,67h0A1.79,1.79,0,0,1,307.72,65.91Z",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M307.75,68.56c-1.28-.72-1.29-1.91,0-2.65a5.05,5.05,0,0,1,4.59,0,1.4,1.4,0,0,1,0,2.65A5.08,5.08,0,0,1,307.75,68.56Z",
					style: { opacity: .1 }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M308.52,272.09a1.75,1.75,0,0,0,1.06,1.45,5.58,5.58,0,0,0,5.05-.05,1.75,1.75,0,0,0,1-1.48h0l-.31-30.8a1.9,1.9,0,0,1-1,1.29,5.64,5.64,0,0,1-5.08.05,1.82,1.82,0,0,1-1-1.31Z",
					style: { fill: "#fafafa" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M309.55,270.62a5.61,5.61,0,0,1,5.05,0,1.54,1.54,0,0,1,0,2.91,5.58,5.58,0,0,1-5.05.05,1.54,1.54,0,0,1,0-2.92Z",
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M303.12,281h0v.22l.13,12.15a1.31,1.31,0,0,0,0,.28v.07h0a4.61,4.61,0,0,0,2.67,3.47,14.2,14.2,0,0,0,12.84-.13c1.77-1.05,2.64-2.41,2.62-3.76h0l-.12-12.3a.13.13,0,0,0,0-.06v-.07h0c-.06-1.31-.95-2.6-2.69-3.58a14.2,14.2,0,0,0-12.84.13A4.62,4.62,0,0,0,303.12,281Z",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M303.12,281h0v.22l.13,12.15a1.31,1.31,0,0,0,0,.28v.07h0a4.61,4.61,0,0,0,2.67,3.47,14.2,14.2,0,0,0,12.84-.13c1.77-1.05,2.64-2.41,2.62-3.76h0l-.12-12.3a.13.13,0,0,0,0-.06v-.07h0c-.06-1.31-.95-2.6-2.69-3.58a14.2,14.2,0,0,0-12.84.13A4.62,4.62,0,0,0,303.12,281Z",
					style: { opacity: .05 }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M305.81,284.82c-3.57-2-3.6-5.33-.08-7.42a14.2,14.2,0,0,1,12.84-.13c3.57,2,3.6,5.33.08,7.41A14.17,14.17,0,0,1,305.81,284.82Z",
					style: { opacity: .1 }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M308.4,62.12h0l0,5.08h0a.81.81,0,0,0,.49.7,2.6,2.6,0,0,0,2.35,0,.85.85,0,0,0,.48-.69h0l.05-5.07h0a1.67,1.67,0,0,0-2.52-1.39A1.7,1.7,0,0,0,308.4,62.12Z",
					style: { fill: "#455a64" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M308.44,61.8h0a1.45,1.45,0,0,0,0,.29v0a.9.9,0,0,0,.5.59,2.6,2.6,0,0,0,2.35,0,.81.81,0,0,0,.47-.67v-.1a.78.78,0,0,0,0-.09,1.39,1.39,0,0,0-.2-.51,1.67,1.67,0,0,0-2.29-.59A1.64,1.64,0,0,0,308.44,61.8Z",
					style: { fill: "#263238" }
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "freepik--post-it--inject-1--inject-4",
			children: [
				/* @__PURE__ */ _jsx("polygon", {
					points: "184.06 372.52 289.67 311.55 391.22 370.18 285.61 431.15 184.06 372.52",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "184.06 372.52 289.67 311.55 391.22 370.18 285.61 431.15 184.06 372.52",
					style: { opacity: .3 }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "184.06 372.52 171.87 365.49 277.48 304.51 289.67 311.55 184.06 372.52",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "184.06 372.52 171.87 365.49 277.48 304.51 289.67 311.55 184.06 372.52",
					style: { opacity: .1 }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "171.87 365.49 171.87 379.56 285.61 445.23 285.61 431.15 171.87 365.49",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "171.87 365.49 171.87 379.56 285.61 445.23 285.61 431.15 171.87 365.49",
					style: { opacity: .2 }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "285.61 431.15 391.22 370.18 391.22 384.25 285.61 445.23 285.61 431.15",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M371.52,349.35h0l-81.85-37.8-105.61,61,101.55,46.91L377,366.66c5.58-3.23,11-8.68,10.66-15.84C384.48,352.41,379.36,353,371.52,349.35Z",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M371.52,349.35h0l-81.85-37.8-105.61,61,101.55,46.91L377,366.66c5.58-3.23,11-8.68,10.66-15.84C384.48,352.41,379.36,353,371.52,349.35Z",
					style: {
						fill: "#fff",
						opacity: .30000000000000004
					}
				}),
				/* @__PURE__ */ _jsxs("g", {
					style: { opacity: .7000000000000001 },
					children: [
						/* @__PURE__ */ _jsx("path", {
							d: "M295.68,332.5a3.08,3.08,0,0,0-.83,1.86c-.51,2.64-1.66,4-4.86,6-1.54.93-1.68,1.66-2.64,2.68-2.24,2.36-3.18.56-5.3-.3-.61-.24-1.32.14-1.2.51.48,1.6,3.16,6.06-1.42,6.33-2.36.14-3.13-1.21-5.1-1.91-2.23-.79-1,4-.78,4.84a14.15,14.15,0,0,1,.28,2.83,3.64,3.64,0,0,1-1.21,3.1,3.58,3.58,0,0,1-1.73.49,12,12,0,0,1-4.82-.37c.26-.62.87-1,1.13-1.7a4.91,4.91,0,0,0,.27-2.34,7.71,7.71,0,0,0-2.33-4.55c-1.07-1-4.16-2.51-6.32-1.55s-1,4-.47,5.21c.82,1.73,2.79,3.46,5.13,4.83a12,12,0,0,1-4,1.2c-2.27.35-4.09.21-4.79,1.72-.36.79.33,2.14-.46,2.79-1.47,1.21-3-.08-4.29.06-1.71.2-2.24.5-2.25,1.62,0,.35.53.87.42,1.18l.28.43a3.77,3.77,0,0,1-2.29-.29c-.31-.08-2-.74-2-.73a1.05,1.05,0,0,0-1.15.3c-.8,1.65-.18,3.25.15,4.87-2.48-3.4-4.17-6.84-8.86-9.69-2.55-1.54-7-3.47-10.18-1.38-4.78,3.19-3.17,11.82,3.37,13.91a.91.91,0,0,0,.76-.22l.54-.51c.46-.43-.26-1-.87-.49-1.22,1-4.23-4.35-4.34-4.72-.54-1.93-.71-4.31.68-6.14,2.94-3.89,9.23.36,11.63,2.36,3.58,3,4.64,6.43,7.46,9.59.46.51,1.61.47,1.74-.13.45-2.11-1-4.19-.55-6.27,1.78.82,4.8,2.31,5.93.76.55-.74-.61-1.61-.25-2.39.54-1.19.37-.46,2.06-.22a5.4,5.4,0,0,0,1.88.06,2.54,2.54,0,0,0,1.57-.95c1.41-1.62-.21-3.33,3.44-4.28,2-.54,3.71-.34,5.51-1.3l.47-.28,1.08.49c3.1,1.29,6.83,1,8.42-1.08a6.75,6.75,0,0,0,1.07-4.44,26.54,26.54,0,0,0,0-3.09,10.68,10.68,0,0,0-.61-1.84c1.73,1,3.24,2.37,5.88,1.57,3.76-1.14,2.9-4.16,2.11-6.37,2.21,1.18,4.22,2.39,5.81-.23.85-1.4,1.13-2.34,3-3.45a17.83,17.83,0,0,0,2.88-1.93c2-1.9.82-4,2.31-5.91C297.43,332.48,296.28,331.9,295.68,332.5ZM262,355.75c-1.5-1.24-2.82-3.11-2.5-4.67.2-1,1.37-2.19,3.29-1.19,1.73.9,2.67,3.47,2.81,4.73a3.47,3.47,0,0,1-1.08,3.05A25.24,25.24,0,0,1,262,355.75Z",
							style: { fill: "#455a64" }
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M316.62,347.94a14.53,14.53,0,0,0-1.93.92,8.19,8.19,0,0,1-4.08,1l.07-.18c.46-1.7-.85-3.82-2.63-5.18a4.22,4.22,0,0,0-4.77-.6c-1.85,1.11-.65,3.21.46,4.34a9,9,0,0,0,4.21,2.31,9.28,9.28,0,0,1-2.73,1.54c-1.63.65-2.39.63-2.45,2a9.32,9.32,0,0,0,.42,2.14c.27,1.38,0,3-3,2.83a11,11,0,0,1-3.79-1c-.58-.24-1.18,0-1.23.37-.17,1.15.34,2.31.28,3.46-.16,3.21-4.73,0-6.15-.95-.74-.51-1.59,0-1.3.55.94,1.76.51,4,0,5.8-.26.93-.65,2.73-2.07,3.35a3.34,3.34,0,0,1-3.69-.65,11.56,11.56,0,0,0,1.37-8.57c-.39-1.38-1.38-3-4.18-2.21-3.36,1-3,3.7-2.35,5.41a18.61,18.61,0,0,0,3.49,5.44c-1.91,3.18-5.42,5.84-9.87,8.48-.57.35-.09,1.09.69.66,4.6-2.54,7.9-4.78,10.23-8.2a4.47,4.47,0,0,0,5.78.21c2.51-1.83,3.21-5.37,2.69-8.12,1.55,1.08,3.5,2.13,5.38,1.53,2.56-.83,1.57-3.45,1.32-5.17,1.94.73,4.41,1.4,6.45.61,3-1.17,1-3.44,1.22-5.05.21-1.9,2.68-1.7,4.41-2.9a4.76,4.76,0,0,0,1.18-1.19c3.05.19,6.17-.78,7.92-2.91a.35.35,0,0,0-.06-.5l-.33-.28C317.05,346.75,316.22,347.56,316.62,347.94ZM280,367c-.77-1.23-2.89-4.46-1.72-6a1.76,1.76,0,0,1,.49-.41,2.48,2.48,0,0,1,2-.15,2.55,2.55,0,0,1,1.63,2.43,19.16,19.16,0,0,1-.2,2.51,10.33,10.33,0,0,1-.94,3.45A19.65,19.65,0,0,1,280,367Zm24.67-19.58a1.94,1.94,0,0,1-.65-1.19,1.47,1.47,0,0,1,1.37-1.39c1.31-.13,2.05.83,2.74,1.73.14.18,1.41,3,.83,2.89a7.1,7.1,0,0,1-4.25-2Z",
							style: { fill: "#455a64" }
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M276.59,390.13c.73,3,3.23,5.6,5.09,8a28.51,28.51,0,0,0,7.11,6.75c.79.5,1.41-.28,1.12-.69a10.49,10.49,0,0,0-1.61-2.23c-.22-.2-.73-.06-1,.15-1.73-1.7-3-3.58-4.45-5.34-1.74-2.06-4.3-4.74-5.08-7C277.61,389.13,276.48,389.71,276.59,390.13Z",
							style: { fill: "#455a64" }
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M292.77,386.7a14.38,14.38,0,0,0-5.31-.09,1.92,1.92,0,0,1,2.76-.29c.59.35,1.37-.47.84-.8a4.51,4.51,0,0,0-4.45.18,2.91,2.91,0,0,0-1.87,2.27s0,.06,0,.09a9.61,9.61,0,0,0,.24,2.2c.4,2.57,2.33,4.67,4.43,6.93a7.68,7.68,0,0,0,6.66,2.7c6.57-.71,5-6.8,2.87-9.12C297.37,389,296.16,387.37,292.77,386.7Zm5.41,10.65c-4.56,4.25-9.59-2.87-10.76-4.62a6,6,0,0,1-1-3.28,4.93,4.93,0,0,1,.29-1.42C294.56,385.41,302.14,393.66,298.18,397.35Z",
							style: { fill: "#455a64" }
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M300.31,382.42a.82.82,0,0,0-.92.34c-.12.3-.27.59-.38.89s.19.29.46.27a.87.87,0,0,0,.69-.35c.11-.16.26-.33.38-.49A.38.38,0,0,0,300.31,382.42Z",
							style: { fill: "#455a64" }
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M312.37,375.17a6.62,6.62,0,0,0-6.4.86c-2,1.5-1.43,3.36-.87,5.1.17.53,1.35.11,1.23-.3a8.1,8.1,0,0,1-.58-2.35c1.6,1.9,3,3.95,4.66,5.93-.14.18-.27.36-.43.53-.36.41.5,1.16,1.13.65l.18-.17a23.24,23.24,0,0,0,4.79,4.15c.82.58,1.84-.33,1.06-.84a24,24,0,0,1-4.94-4.33c.47-.67.83-1.4,1.27-2.07a8.92,8.92,0,0,0,1.45-2.73C315.32,378,314.68,376.27,312.37,375.17Zm0,1.37c2,1.49,1.15,3.2.08,4.8-.42.63-.82,1.29-1.24,1.94-1.6-1.91-3-3.88-4.55-5.69a.6.6,0,0,0-.65-.16c0-.06.06-.12.1-.18C307.25,375.72,310.47,375.11,312.39,376.54Z",
							style: { fill: "#455a64" }
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M340.57,368.47a4.44,4.44,0,0,1-2.36,1.87c-2.39.92-4.57-.21-6.21-1.29-1.44-1-1.81-2.33-3-3.37a4.3,4.3,0,0,0-3.68-1.3c-3.68.82-2,5.15-1.5,7.57a7.35,7.35,0,0,0-3.69-1.06.88.88,0,0,0-.72.25,3.1,3.1,0,0,0-.35,3c-1.45-1.2-2.85-2.42-4.27-3.63-.61-.53-1.62.2-1.13.63,2.43,2.13,4.81,4.26,7.49,6.29.69.53,1.42.06,1.12-.74-.25-.64-1.15-1.13-1.55-1.7a1.71,1.71,0,0,1-.15-2,1.47,1.47,0,0,1,1.11-.48,3.39,3.39,0,0,1,1.21.24c.57.2,2.57,1.71,2.51.31A31.75,31.75,0,0,0,325,369a3.23,3.23,0,0,1,0-1.8,1.67,1.67,0,0,1,1.29-1,2.09,2.09,0,0,1,1.59.44c1.08.85,1.66,2.07,2.68,3a9.5,9.5,0,0,0,2.49,1.67c3.92,1.72,8.45-.33,8.68-2.84C341.82,367.93,340.71,368.06,340.57,368.47Z",
							style: { fill: "#455a64" }
						})
					]
				})
			]
		})
	]
});
export default SvgNoNotes;
